export enum StatusBed {
  Active = 1,
  Inactive = 2,
}
